module.exports = __webpack_public_path__ + "77544a237974f5e2a0fbcc78adbfe638.glb";